import { render, staticRenderFns } from "./ArticlePickerPromt.vue?vue&type=template&id=2f1ba05c&scoped=true&"
import script from "./ArticlePickerPromt.vue?vue&type=script&lang=js&"
export * from "./ArticlePickerPromt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1ba05c",
  null
  
)

export default component.exports